module.exports = __webpack_public_path__ + "media/images/icons/flags/UZ-a1bc79fe52f18a786385b176915cf3cc.svg";